import { useEffect, useState } from "react";
import { api, fmtDate, errDetail } from "../lib/api";
import { useApp } from "../lib/store";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { MessageSquare, History } from "lucide-react";

export function CommentsAudit({ module, id }) {
  const { t, canWrite } = useApp();
  const [comments, setComments] = useState([]);
  const [auditLog, setAuditLog] = useState([]);
  const [text, setText] = useState("");

  const load = () => {
    api.get(`/${module}/${id}/comments`).then((r) => setComments(r.data)).catch(() => {});
    api.get(`/${module}/${id}/audit`).then((r) => setAuditLog(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, [module, id]);

  const post = async () => {
    if (!text.trim()) return;
    try {
      await api.post(`/${module}/${id}/comments`, { text });
      setText("");
      load();
    } catch (e) { toast.error(errDetail(e)); }
  };

  return (
    <Tabs defaultValue="comments">
      <TabsList className="bg-gray-100">
        <TabsTrigger value="comments" data-testid="tab-comments"><MessageSquare className="h-3.5 w-3.5 mr-1.5" />{t("comments")}</TabsTrigger>
        <TabsTrigger value="audit" data-testid="tab-audit"><History className="h-3.5 w-3.5 mr-1.5" />{t("audit_trail")}</TabsTrigger>
      </TabsList>
      <TabsContent value="comments" className="space-y-3">
        {canWrite && (
          <div className="flex gap-2">
            <Textarea data-testid="comment-input" rows={2} placeholder={t("add_comment")} value={text} onChange={(e) => setText(e.target.value)} />
            <Button className="bg-[#1B2A4A] hover:bg-[#2a3d63] text-white self-end" onClick={post} data-testid="comment-post-btn">{t("post")}</Button>
          </div>
        )}
        {comments.map((c) => (
          <div key={c.id} className="bg-gray-50 rounded-md p-3 text-sm" data-testid="comment-item">
            <div className="flex justify-between text-xs text-gray-500 mb-1">
              <span className="font-medium text-gray-700">{c.user_name}</span>
              <span>{fmtDate(c.created_at)}</span>
            </div>
            {c.text}
          </div>
        ))}
        {comments.length === 0 && <p className="text-sm text-gray-400">–</p>}
      </TabsContent>
      <TabsContent value="audit" className="space-y-2">
        {auditLog.map((a) => (
          <div key={a.id} className="text-xs border-l-2 border-amber-400 pl-3 py-1" data-testid="audit-item">
            <span className="font-medium">{a.user_name}</span> · {a.action} · {fmtDate(a.timestamp)}
            {Object.keys(a.changes || {}).length > 0 && (
              <div className="text-gray-500 mt-0.5 font-mono">
                {Object.entries(a.changes).slice(0, 5).map(([k, v]) => (
                  <div key={k}>{k}: {JSON.stringify(v.from)} → {JSON.stringify(v.to)}</div>
                ))}
              </div>
            )}
          </div>
        ))}
        {auditLog.length === 0 && <p className="text-sm text-gray-400">–</p>}
      </TabsContent>
    </Tabs>
  );
}
